import angular from 'angular';
import uiRouter from '@uirouter/angularjs';

import forgotpasswordComponent from './forgotpassword.component';
import formComponent from './component/form.component';

let forgotpasswordModule = angular.module('forgotpassword', [
  uiRouter
])

.config(($stateProvider, $urlRouterProvider) => {
  'ngInject';

  $stateProvider
  .state('forgotpassword', {
    url: '/forgot-password',
    component: 'forgotpassword'
  })
  ;
})
.component('forgotpassword', forgotpasswordComponent)
.component('forgotPasswordForm', formComponent)
.name;

export default forgotpasswordModule;



// WEBPACK FOOTER //
// ./client/app/pages/forgotpassword/forgotpassword.js